import React, {useEffect} from 'react'
import moment from 'moment';
import {Shift} from '../../../../features/shifts/types';
import {useAppDispatch, useAppSelector} from '../../../../hooks/hooks';
import useModal from '../../../../hooks/useModal';
import {deleteShift} from '../../../../features/shifts';
import {useIntl} from 'react-intl';
import {Lx} from '../../../../i18n/consts';
import {DeleteDialog} from '../../../shared/delete-dialog';

interface Props {
    shift: Shift,
    onDelete: (item: Shift) => void,
    onCancel: () => void,
}

export default function DeleteShiftModal(props: Props) {
    const dispatch = useAppDispatch();
    const employees = useAppSelector((store) => store.rEmployees);
    const {open, onToggle, openModal} = useModal();
    const intl = useIntl();
    const employeeName = employees.find((employee) => employee.id === props.shift.employeeId)?.name ?? '';
    const date = moment(props.shift.date, 'YYYY-MM-DD', true);
    const formattedDate = date.isValid() ? date.format('L') : props.shift.date;
    const deleteMessage = employeeName
        ? `Delete shift for ${employeeName} on ${formattedDate}?`
        : `Delete shift on ${formattedDate}?`;

    useEffect(() => {
        openModal();
    }, [])

    const handleCancel = () => {
        onToggle();
        props.onCancel();
    }

    const handleConfirmDelete = () => {
        dispatch(deleteShift(props.shift.id)).unwrap().then(() => {
            props.onDelete(props.shift)
            onToggle();
        })
    }

    return (
        <DeleteDialog
            open={open}
            onCancel={handleCancel}
            onConfirmDelete={handleConfirmDelete}
            deleteHeader={intl.formatMessage({id: Lx.General.DELETE})}
            deleteMessage={deleteMessage}
            title='shift'
        />
    );
}
